<template>
  <button
    class="sb-data-table__column-button"
    :disabled="disabled"
    v-bind="rootProps"
    @click="handleClick"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
import { reactiveOmit } from '@vueuse/core'
import type { ButtonHTMLAttributes } from 'vue'

type ComponentProps = {
  disabled?: boolean
  // eslint-disable-next-line vue/prop-name-casing
} & /* @vue-ignore */ ButtonHTMLAttributes
const props = defineProps<ComponentProps>()
const rootProps = reactiveOmit(props, ['disabled'])

type ComponentEmits = {
  (e: 'click', event: MouseEvent): void
}
const emit = defineEmits<ComponentEmits>()

const handleClick = (event: MouseEvent) => {
  if (!props.disabled) {
    emit('click', event)
  }
}
</script>

<style lang="scss">
@import '@storyblok/design-tokens/tokens/scss/typography/semantic-mixins';

.sb-data-table__column-button {
  @include resetButtonStyle;
  @include text-body-base-regular;

  width: 100%;
  min-height: 45px;
  padding: 0 10px;
  color: inherit;
  text-align: left;

  &:focus,
  &:focus-visible {
    outline: 1px solid $sb-color-border-brand-primary;
  }

  &:disabled {
    cursor: default;
  }
}
</style>
